import { Button, ButtonProps } from "antd";
import { forwardRef } from "react";
import useReadonly from "src/hook/useReadonly";

/**
 * AntD Button which is disabled when user is readonly
 * @param props AntD Button properties
 * @param ignoreReadonly optional disable of readonly behavior
 * @returns
 */
export const XmButton = forwardRef<HTMLButtonElement, ButtonProps & { ignoreReadonly?: boolean }>(
  ({ ignoreReadonly, disabled, ...props }, ref) => {
    const { isDisabled } = useReadonly(ignoreReadonly, disabled)

    return (
      <Button
        ref={ref}
        {...props}
        disabled={isDisabled}
      />
    )
  }
)